import { ChevronLeft, ChevronRight } from 'lucide-react'

export function PropertyPagination({ offset, nextOffset, total, loading, onChange, pageSize = 20 }: {
  offset: number; nextOffset: number | null; total?: number; loading?: boolean; pageSize?: number; onChange: (offset: number) => void
}) {
  if (offset === 0 && nextOffset === null && (total === undefined || total <= pageSize)) return null
  return <nav className="property-article-pagination" aria-label="Halaman data" aria-busy={loading}>
    <button type="button" disabled={loading || offset === 0} onClick={() => onChange(Math.max(0, offset - pageSize))}><ChevronLeft size={18} /> Sebelumnya</button>
    <span>Halaman {Math.floor(offset / pageSize) + 1}{total !== undefined ? ` / ${Math.max(1, Math.ceil(total / pageSize))}` : ''}</span>
    <button type="button" disabled={loading || nextOffset === null} onClick={() => nextOffset !== null && onChange(nextOffset)}>Berikutnya <ChevronRight size={18} /></button>
  </nav>
}
